import { Box, Flex, FloraButton, Tooltip } from '@grupoboticario/flora-react';
import { useNavigate } from 'react-router-dom';
import slugify from 'slugify';

import { getMessageStatusValue } from 'components/Drawers/CadastralChange/helpers';
import { FeatureFlag } from 'domains/feature-flag.d';
import { ResellerRegistrationDetail } from 'domains/reseller-registration.d';
import { useFeatureFlag, useResellerRegistration, useTracking } from 'hooks';
import { useRegistrationControllerContext } from 'store';

export const EditButton = () => {
  const { data: registration } = useResellerRegistration();
  const navigate = useNavigate();
  const { sendDataToGTM } = useTracking();

  const { handleStart } = useRegistrationControllerContext();

  const { disableEdit, disableEditMessage } =
    (registration?.address as ResellerRegistrationDetail) || {};

  const isEnabledCadastralChange = useFeatureFlag(
    FeatureFlag.ENABLE_CADASTRAL_CHANGE_ADDRESS,
    false
  ).value as string;

  const handleOpenAddress = () => {
    handleStart();
    navigate('/perfil/editar/endereco/senha');
  };

  const handleOnTooltipTracking = (method: string) => {
    const status = registration?.address?.status ?? '';
    return () => {
      sendDataToGTM({
        event: 'analytics-event',
        event_parameters: {
          event_name: 'interaction_perfil',
          cd_interaction_detail: `view:tooltip:${method}`,
          ...(status !== 'none' && {
            cd_status_alteracao: slugify(`endereco:${getMessageStatusValue(status)}`, {
              lower: true,
            }),
          }),
        },
      });
    };
  };

  if (!isEnabledCadastralChange) {
    return null;
  }

  if (disableEdit) {
    return (
      <Flex direction='column' gap='$2'>
        <Tooltip
          data-testid='tooltip-editable-address'
          align='end'
          direction='left'
          showArrow
          size='standard'
          text={disableEditMessage}
        >
          <Box onClick={handleOnTooltipTracking('endereco')}>
            <FloraButton size='small' hierarchy='primary' disabled={disableEdit}>
              <Flex gap='$2'>Editar</Flex>
            </FloraButton>
          </Box>
        </Tooltip>
      </Flex>
    );
  }

  return (
    <Flex direction='column' gap='$2'>
      <FloraButton
        size='small'
        data-autotagging-flora-section='perfil'
        autotagging-flora='on'
        data-flora-text='editar-endereco'
        data-flora='button'
        data-testid='button-edit-address'
        hierarchy='secondary'
        onClick={handleOpenAddress}
      >
        <Flex gap='$2'>Editar</Flex>
      </FloraButton>
    </Flex>
  );
};
